import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunk from "redux-thunk"
import authReducer from "./reducers/auth/auth";
import apolloClient from './reducers/apolloClient';
import notification from './reducers/notification';
import experienceReducer from './reducers/experience/experience';
import creatorOnBoardingReducer from './reducers/creator/creatorOnBoarding';
import creatorExperienceBuilderReducer from './reducers/creator/creatorExperienceBuilder';
import creatorDashboardReducer from './reducers/creator/creatorDashboard';
import participantReducer from './reducers/participant/experience';
import creatorExperienceManagerReducer from './reducers/creator/creatorExperienceManager';
import participantList from './reducers/participant/list';

import adminRoleReducer from './reducers/admin/role';
import adminUserReducer from './reducers/admin/user';
import video from './reducers/videos/video';
import analysis from './reducers/creator/analysis';
import compare from './reducers/creator/compare';
import liveParticipants from './reducers/liveParticipants';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  apolloClient: apolloClient,
  notification: notification,
  authUser: authReducer,
  experience: experienceReducer,
  creatorOnBoarding: creatorOnBoardingReducer,
  creatorExperienceBuilder: creatorExperienceBuilderReducer,
  creatorDashboard: creatorDashboardReducer,
  creatorExperienceManager: creatorExperienceManagerReducer,
  adminRole: adminRoleReducer,
  adminUser: adminUserReducer,
  participant: participantReducer,
  video:video,
  analysis: analysis,
  compare: compare,
  participantList: participantList,
  liveParticipants: liveParticipants

});

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk))
);

export default store